import axios from "axios";

export default {
  name: "promoSection",
  data() {
    return {
      eventActive: [],
    };
  },
  async created() {
    axios
      .post("https://giftstore-blog.herokuapp.com/api/bestSelling/getActive")
      .then((response) => {
        console.log("cata", response);
        this.eventActive = response.data.bestSelling;
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  },
  methods: {
    linkEvent() {
      return "/articles-Filtre?filtre=" + this.eventActive.category;
    },
    // eventName() {
    //   return this.eventActive[0].category;
    // },
    imgCategorie() {
      console.log( this.eventActive)
      return (
        "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
        this.eventActive.image
      );
    },
  },
};
